// extracted by mini-css-extract-plugin
export default {"overlay":"DB-z","bodyOpen":"EB-z","content":"FB-z","header":"GB-z","close":"HB-z","closeNoHeading":"IB-z"};